import { useContext } from "react";
import PreviewModalContext from "./PreviewModal.context";

export const usePreviewModal = () => {
  return useContext(PreviewModalContext);
};
